import moment from "moment";
import ApiReturnJson from "../api/ApiReturnJson";
import * as EP from "./Api"; // EP stands for EndPoint
import { signOutUser } from "./ApiService";


// Report apis
export const fetcgAISummaryEndpoint = async (req) => {
    try {
        const [response] = await Promise.all([
            ApiReturnJson("POST", `${EP.aiSummaryEndpoint}`, req),
        ]);

        if (response.isSuccess) {
        return response.data;
        } else {
        console.error(response);
        return [];
        }

    } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
        signOutUser();
        }
    }
};